import { filterSeparators } from './helpers';
import { separatorString } from './constants';
class ItemsMap extends Map {
    toArr() {
        return this.sort([...this]);
    }
    toItems() {
        return this.toArr().map(([key]) => key);
    }
    toItemsWithoutSeparators() {
        return filterSeparators(this.toItems());
    }
    // NOTE: for backward compatibility, to remove
    toItemsKeys() {
        return this.toItems();
    }
    sort(arr) {
        return arr.sort(([, IOItemA], [, IOItemB]) => +IOItemA.index - +IOItemB.index);
    }
    set(key, val) {
        if (Array.isArray(key)) {
            this.sort(key).forEach(([itemId, ioitem]) => {
                super.set(String(itemId), ioitem);
            });
        }
        else {
            super.set(String(key), val);
        }
        return this;
    }
    first() {
        var _a;
        return (_a = this.toArr()[0]) === null || _a === void 0 ? void 0 : _a[1];
    }
    last() {
        var _a, _b;
        return (_b = (_a = this.toArr().slice(-1)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[1];
    }
    filter(predicate) {
        return this.toArr().filter(predicate);
    }
    find(predicate) {
        return this.toArr().find(predicate);
    }
    findIndex(predicate) {
        return this.toArr().findIndex(predicate);
    }
    getCurrentPos(item, onlyItems) {
        const arr = this.toArr().filter((el) => { var _a; return onlyItems ? !((_a = el === null || el === void 0 ? void 0 : el[0]) === null || _a === void 0 ? void 0 : _a.includes(separatorString)) : el; });
        const current = arr.findIndex(([itemId, ioitem]) => itemId === item || ioitem === item);
        return [arr, current];
    }
    prev(item, onlyItems) {
        var _a;
        const [arr, current] = this.getCurrentPos(item, !!onlyItems);
        return current !== -1 ? (_a = arr[current - 1]) === null || _a === void 0 ? void 0 : _a[1] : undefined;
    }
    next(item, onlyItems) {
        var _a;
        const [arr, current] = this.getCurrentPos(item, !!onlyItems);
        return current !== -1 ? (_a = arr[current + 1]) === null || _a === void 0 ? void 0 : _a[1] : undefined;
    }
    getVisible() {
        return this.filter((value) => value[1].visible);
    }
    getVisibleElements() {
        return this.filter((value) => !value[0].includes(separatorString) && value[1].visible);
    }
}
export default ItemsMap;
